/**
 * Implement a service to interact with backend API to create purchase order.
 * This service will be called from the action component when the user clicks on the create PO button.
 */

import { successToastOptions, errorToastOptions } from "../components/orders/constants";
import apiEndpoints from "../config/config";
import axios from "axios";
import { toast } from "react-toastify";

/**
 * Function to handle the PO creation and
 * once successful update the orders table with returned PO internal ID and PO number
 * and change the task states to work in progress and rahi's workflow_status to pending item fulfillment
 * and place the message in the pub/sub topic for responding back
 * Also, throw a success message to the user
 *
 * If failed, throw the error message to the user
 * and don't respond back to the pub/sub response topic
 *
 * @param {Object} data
 * @returns
 */
export const handleCreatePO = async (data) => {
  // console.log('handleCreatePO ', data)
  const loading = toast.loading("Creating PO");

  /**
   * Call Netsuite API to create PO
   */
  try {
    let authHeader = sessionStorage.getItem("accessToken");
    let headers = { Authorization: authHeader };

    await axios({
      url: `${apiEndpoints.CREATE_PO}`,
      method: "POST",
      data: data ? data : null,
      headers,
      withCredentials: true,
    });

    toast.update(
      loading,
      successToastOptions("Created Purchase Order Successfully!"),
    );
  } catch (err) {
    console.error("Unable to Create PO", err);

    toast.update(
      loading,
      errorToastOptions("Error while creating Purchase Order!"),
    );
  }
};
